/*
* @author 友人a丶
* @date 2022-07-11
*
* 保存登录后的用户信息
* */

import {defineStore} from "pinia";
import Cookies from "js-cookie";
import config from "@/config";
import {toRaw} from "vue";

export default defineStore('user', {
    state() {
        /*初始数据列表*/
        return {
            nickname: "",
            jifen: "",
            GameStatus: "",
            SteamID: "",
            level: "",
            clan_create_auth: null,
            longhun: "",
            token: "",
            role: 1,
            clan_id: "",
            routes: [],
            board: false
        }
    },
    actions: {

        /**
         * 设置保存token
         */
        setToken(state) {
            /*如果是token模式*/
            if (config.auth.mode === "token") {
                Cookies.set(config.auth.token, state.token); //保存token
            }
        },

        /*
        * 保存用户信息
        * 系统支持token和cookie两种模式
        * token模式下会在axios请求时，添加token请求头（可在拦截器内自定义）
        * */
        save(state) {

            /* 转换 */
            state.nickname = state.SteamName; //昵称
            state.routes = toRaw(state.routes); //昵称
            state.GameStatus = parseInt(state.GameStatus);
            state.token = Cookies.get(config.auth.token);
            state.board = false; //没有看过公告
            //state.role = 5; //没有看过公告
            this.$state = state;//保存用户信息
        }
    }
})